var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExcel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.823,
    height: 21.101,
    viewBox: "0 0 15.823 21.101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3667",
    d: "M8.117-12.591 4.66-16.048a1.978 1.978 0 0 0-1.4-.581h-8.41a1.985 1.985 0 0 0-1.978 1.982V2.495a1.978 1.978 0 0 0 1.981 1.978H6.72A1.978 1.978 0 0 0 8.7 2.495V-11.19a1.987 1.987 0 0 0-.583-1.401zm-.931.935a.648.648 0 0 1 .173.3H3.424v-3.935a.648.648 0 0 1 .3.173zM6.72 3.154H-5.147a.661.661 0 0 1-.659-.659v-17.142a.661.661 0 0 1 .659-.659H2.1v4.285a.987.987 0 0 0 .989.989h4.29V2.495a.661.661 0 0 1-.659.659zM1.6-3.933 3.679-7.3a.494.494 0 0 0-.424-.75h-.169a.5.5 0 0 0-.416.227A23.246 23.246 0 0 0 .786-4.757 28.172 28.172 0 0 0-1.1-7.827a.5.5 0 0 0-.416-.227h-.169a.492.492 0 0 0-.42.75L0-3.933-2.432-.245a.5.5 0 0 0 .416.762h.144A.5.5 0 0 0-1.455.29C.078-2.1.411-2.285.786-3.109A24.366 24.366 0 0 0 3.028.294a.491.491 0 0 0 .412.223h.148A.492.492 0 0 0 4-.241z",
    transform: "translate(7.125 16.629)",
    fill: "#f8f9fa"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.78ce9df9.svg";
export { ForwardRef as ReactComponent };